import useGlobalSettings from '@components/_hooks/useGlobalSettings'
import Box from '@mui/material/Box';


const Wrapper = ({children}) => (<Box className="boxed-padding">{children}</Box>)

const CanAccessPortal = ({children}) => {
    const { getSetting } = useGlobalSettings();

    if(getSetting('portal_status', 'enabled') == 'disabled'){
        return (
            <Wrapper>
                <h3>Redirecting...</h3>
            </Wrapper>
        )
    }

    return children;
}

export default CanAccessPortal